module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/5742ea94a0bb45fd1e384bdacbdc1112.png";